/**
 * Mdast to Lexical Visitor for Secret Field
 * Imports markdown AST to SecretFieldNode
 *
 * Handles inline format (textDirective) only.
 */

import { $createSecretFieldNode } from './SecretFieldNode';
import type { MdastImportVisitor } from '@mdxeditor/editor';
import { $isElementNode } from 'lexical';

/**
 * Visitor that converts mdast (markdown AST) to SecretFieldNode
 * Processes inline format only (::secret[Label]{content}::)
 */
export const MdastSecretFieldVisitor: MdastImportVisitor<any> = {
  testNode: (node) => {
    // Only support textDirective (inline format)
    return node.type === 'textDirective' && node.name === 'secret';
  },

  visitNode({ mdastNode, lexicalParent }) {
    const label = mdastNode.attributes?.label || '';
    let content = '';

    // Extract text directly from children
    if (mdastNode.children && mdastNode.children.length > 0) {
      const textNode = mdastNode.children.find((child: any) => child.type === 'text');
      if (textNode) {
        content = textNode.value || '';
      }
    }

    // Create and append the node directly to avoid processing children
    // DecoratorNodes don't have Lexical children to process
    const node = $createSecretFieldNode(label, content, 'inline');

    if ($isElementNode(lexicalParent)) {
      lexicalParent.append(node);
    }
  }
};

